import React, {Fragment} from 'react';
import classNames from 'classnames';
import Button, {ButtonProps as ButtonPropsType} from "../form/Button";
import {isTrue} from "../../utils/other";
import {ReactComponentLike} from "prop-types";

const zIndexCounter: any[] = [];

const sizes = {
    large: 'lg',
    medium: 'md',
    small: 'sm'
}

export const isOpened = (state: any) => {
    return state === 'on' || isTrue(state);
}

type ModalState = {
    state: boolean
};

export type ButtonProps = {
    text?: any,
    props?: ButtonPropsType,
    focus?: boolean,
    onClick?: ButtonPropsType['onClick'],
    className?: ButtonPropsType['className'],
    onClose?: boolean,
};

export type ModalProps = {
    state?: true|false|"0"|"1"|0|1|"on"|"off",
    timeout?: number,
    disabled?: boolean,
    onClose?: () => void,
    closeAble?: boolean,
    texts?: any,
    buttons?: (ButtonProps|ReactComponentLike)[],
    theme?: string,
    size?: "large"|"medium"|"small",
    header?: any,
    body?: any,
    footer?: any,
    className?: any,
    container?: React.Component|React.FunctionComponent|JSX.Element,
};

class Modal extends React.Component<ModalProps, ModalState> {

    private autoclose: number;
    private el: any;
    private closing: boolean;

    constructor(props: ModalProps) {
        super(props);
        this.state = {
            state: isOpened(this.props.state)
        };
        if (this.state.state) {
            zIndexCounter.push(this);
        }
        if (this.props.timeout) {
            const {onCloseCb} = this.getButtons();
            this.autoclose && clearTimeout(this.autoclose);
            this.autoclose = setTimeout(() => {
                onCloseCb && onCloseCb();
            }, this.props.timeout);
        }
    }

    onCloseAction = (event) => {
        if ([27].indexOf(event.which) !== -1) {
            if (this.state.state || isOpened(this.props.state)) {
                let i = zIndexCounter.indexOf(this);
                if (i === zIndexCounter.length - 1) {
                    this.hide();
                }
            }
        }
    }

    componentDidMount() {
        let i = zIndexCounter.indexOf(this);
        if (i === -1) {
            zIndexCounter.push(this);
        }
        document.addEventListener("keydown", this.onCloseAction, false);
    }

    componentWillUnmount() {
        let i = zIndexCounter.indexOf(this);
        if (i !== -1) {
            zIndexCounter.splice(i, 1);
        }
        document.removeEventListener("keydown", this.onCloseAction, false);
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (this.props.state !== prevProps.state && this.state.state !== isOpened(this.props.state)) {
            const state = isOpened(this.props.state);
            let i = zIndexCounter.indexOf(this);
            if (i === -1 && state) {
                zIndexCounter.push(this);
            } else if (i !== -1 && !state) {
                zIndexCounter.splice(i, 1);
            }
            this.setState({state});
            return;
        }
        let i = zIndexCounter.indexOf(this);
        if (!this.state.state && i !== -1) {
            zIndexCounter.splice(i, 1);
        } else if ((!prevState.state && this.state.state) || (!isOpened(prevProps.state) && isOpened(this.props.state))) {
            if (i !== -1) {
                zIndexCounter.splice(i, 1);
            }
            zIndexCounter.push(this);
        }
        if (this.state.state) {
            let i = zIndexCounter.indexOf(this);
            if (i === zIndexCounter.length - 1) {
                document.body.addEventListener("keydown", this.onCloseAction);
            } else {
                document.body.removeEventListener("keydown", this.onCloseAction);
            }
        } else {
            document.body.removeEventListener("keydown", this.onCloseAction);
        }
        if (this.props.timeout) {
            const {onCloseCb} = this.getButtons();
            this.autoclose && clearTimeout(this.autoclose);
            this.autoclose = setTimeout(() => {
                onCloseCb && onCloseCb();
            }, this.props.timeout);
        }
    }

    bringToFront = () => {
        let i = zIndexCounter.indexOf(this);
        if (i !== -1) {
            zIndexCounter.splice(i, 1);
        }
        zIndexCounter.push(this);
    }

    show = () => {
        this.setState({
            state: true
        }, () => this.bringToFront());
    }

    focus = () => {
        this.setState({
            state: true
        }, () => {
            this.bringToFront();
            this.el.focus()
        });
    }

    hide = () => {
        if (!this.props.disabled) {
            const {onCloseCb} = this.getButtons();
            onCloseCb && onCloseCb();
        }
    }

    getButtons = () => {
        const closeActions = [];
        const onCloseCb = async () => {
            if (this.closing) return;
            this.closing = true;
            try {
                await closeActions.reduce(async (previousPromise, nextAsyncFunction) => {
                    await previousPromise;
                    await nextAsyncFunction();
                }, Promise.resolve());
            } catch (e) {
                console.log(e);
            }
            this.closing = false;
        };
        let buttontexts = {
            "OK": "OK",
            "CLOSE": "Bezárás",
            "YES": "Igen",
            "NO": "Nem",
            "CANCEL": "Mégsem"
        };
        if (this.props.texts) buttontexts = {...buttontexts, ...this.props.texts};
        let closeButton = false;
        const buttons = (this.props.buttons || []).map(
            (buttondata, idx) => {
                let buttontype = undefined;
                let text = undefined;
                let buttonClassNames = "";
                let attributes: ButtonPropsType = {};
                let cb: (event: Event) => void = () => {};
                if (buttondata && typeof(buttondata) === 'object' && buttondata.type && buttondata.props) {
                    cb = buttondata.props.onClick || cb;
                    if (buttondata.props.onClose && !buttondata.props.disabled) {
                        closeActions.push(cb);
                    }
                    return <buttondata.type
                        key={idx}
                        {...buttondata.props}
                        data-dismiss="modal"
                        onClick={(e) => cb && cb(e)}
                    />
                } else if (buttondata && buttondata instanceof Function) {
                    const Comp = buttondata;
                    return <Comp
                        key={idx}
                        data-dismiss="modal"
                        onClick={(e) => cb && cb(e)}
                    />;
                } else if (typeof(buttondata) === 'object') {
                    text = buttondata.text || text;
                    attributes = {...(buttondata.props || attributes || {})};
                    attributes.color = attributes.color || "default";
                    cb = buttondata.onClick || cb;
                    if (buttondata.onClose && !attributes.disabled) {
                        closeActions.push(cb);
                    }
                    buttonClassNames = buttondata.className || buttonClassNames;
                } else {
                    attributes.color = "default";
                    buttontype = buttondata;
                    text = buttontexts[buttontype];
                    if (buttontype === "CLOSE" && !attributes.disabled) {
                        closeButton = true;
                    }
                }
                if (text !== undefined) {
                    return <Button
                        key={idx}
                        {...attributes}
                        className={buttonClassNames}
                        data-dismiss="modal"
                        onClick={(e) => cb && cb(e)}
                    >
                        {text}
                    </Button>
                }
            }
        ).filter((button) => button !== undefined);
        if (this.props.closeAble !== false || closeButton) {
            const fn = this.props.closeAble;
            const onClose = this.props.onClose;
            closeActions.push(async () => {
                if (fn instanceof Function) {
                    if (closeActions.indexOf(fn) === -1) {
                        await fn();
                    }
                }
                if (closeActions.indexOf(onClose) === -1) {
                    onClose && await onClose();
                }

                let i = zIndexCounter.indexOf(this);
                if (i !== -1) {
                    zIndexCounter.splice(i, 1);
                }
                this.setState({
                    state: false
                });
            });
        }
        return {buttons, onCloseCb: closeActions.length ? onCloseCb : undefined};
    }

    deserialize = (children) => {
        if (Array.isArray(children)) {
            children = children.map((child, idx) => {
                if (child !== null && child !== undefined && child instanceof Object && child.type) {
                    return React.createElement(child.type, {
                        ...child.props,
                        children: this.deserialize(child.props.children),
                        key: idx,
                        ref: child.ref
                    });
                } else {
                    return child;
                }
            });
        } else if (children !== null && children !== undefined && children instanceof Object && children.type) {
            children = React.createElement(children.type, {
                ...children.props,
                children: this.deserialize(children.props.children),
                ref: children.ref
            });
        }
        return children;
    }

    render() {
        let zIndex = zIndexCounter.indexOf(this);
        const theme = this.props.theme || 'default';
        const display = this.state.state ? {display: 'block'} : {display: 'none'};
        const {buttons, onCloseCb} = this.getButtons();
        let Container = this.props.container || Fragment;
        return this.state.state ? <Container>
            <div
                className={classNames("modal modal-" + theme + " fade ", {"in show": this.state.state}, this.props.className)}
                style={{...display, zIndex: 10000 + zIndex}}
            >
                <div
                    ref={(el) => this.el = el}
                    tabIndex={0}
                    className={"modal-dialog modal-" + (this.props.size ? sizes[this.props.size] : "sm")}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">
                                {this.props.header}{!this.props.header && <span>&nbsp;</span>}
                            </h4>
                            {onCloseCb && <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onCloseCb()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>}
                        </div>
                        {(this.props.body || this.props.children) ? <div className="modal-body">
                            {this.state.state && this.deserialize(this.props.body || this.props.children)}
                        </div> : null}
                        {(!!this.props.footer || !!buttons.length) && <div className="modal-footer">
                            <div className="center-block">
                                {this.props.footer}
                                {buttons}
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
            <div onClick={(e) => {onCloseCb && onCloseCb(e)}} className={classNames("modal-backdrop fade ", {"in show": this.state.state})} />
        </Container> : null;
    }
}

export default Modal;